import { render, staticRenderFns } from "./PublicDetails.vue?vue&type=template&id=93ba731c&scoped=true&"
import script from "./PublicDetails.vue?vue&type=script&lang=js&"
export * from "./PublicDetails.vue?vue&type=script&lang=js&"
import style0 from "./PublicDetails.vue?vue&type=style&index=0&id=93ba731c&scoped=true&lang=less&"
import style1 from "./PublicDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba731c",
  null
  
)

export default component.exports